import Vue from "vue";
import VueProgressBar from "vue-progressbar";

Vue.use(VueProgressBar, {
  location: "top",
  color: "#f37946",
  failedColor: "#ff0000",
  thickness: "3px",
  transition: {
    speed: "0.3s",
    opacity: "0.6s",
    termination: 800,
  },
  autoRevert: true,
  inverse: false,
});
